import { CheckCircle2, AlertTriangle, Loader2, RefreshCw } from 'lucide-react'

const QUALIDADE = {
  GREEN: { label: 'Boa', classe: 'bg-green-100 text-green-800' },
  YELLOW: { label: 'Atenção', classe: 'bg-amber-100 text-amber-800' },
  RED: { label: 'Ruim', classe: 'bg-red-100 text-red-800' },
}

function Linha({ rotulo, children }) {
  return (
    <div className="flex items-center justify-between py-2.5 border-b border-gray-100 last:border-0">
      <span className="text-sm text-gray-600">{rotulo}</span>
      <span className="text-sm font-medium text-gray-900">{children}</span>
    </div>
  )
}

function Qualidade({ rating }) {
  const q = QUALIDADE[rating]
  if (!q) return <span className="text-gray-400">—</span>
  return (
    <span className={`rounded-full px-2.5 py-0.5 text-xs font-medium ${q.classe}`}>
      {q.label}
    </span>
  )
}

export function Account({ account, onRetrySync }) {
  const sincronizando = account.status === 'syncing'
  const suspenso = account.status === 'suspended'

  return (
    <div className="flex flex-col gap-4 w-full">
      {sincronizando && (
        <div className="flex gap-3 items-start rounded-md bg-blue-50 border border-blue-200 p-4">
          <Loader2 className="w-5 h-5 mt-0.5 text-blue-600 shrink-0 animate-spin" />
          <div className="flex-1">
            <p className="font-medium text-blue-900">Sincronizando seus dados</p>
            <p className="text-sm text-blue-800 mt-0.5">
              Estamos trazendo seus contatos e o histórico de conversas. Pode
              levar alguns minutos. Você já pode usar o WhatsApp normalmente no
              celular.
            </p>
            <button
              type="button"
              onClick={onRetrySync}
              className="mt-2 inline-flex items-center gap-1.5 text-sm font-medium text-blue-700 hover:text-blue-900"
            >
              <RefreshCw className="w-3.5 h-3.5" />
              Tentar novamente
            </button>
          </div>
        </div>
      )}

      {suspenso && (
        <div className="flex gap-3 items-start rounded-md bg-red-50 border border-red-200 p-4">
          <AlertTriangle className="w-5 h-5 mt-0.5 text-red-600 shrink-0" />
          <div>
            <p className="font-medium text-red-900">Envios pausados</p>
            <p className="text-sm text-red-800 mt-0.5">
              {account.error ||
                'A Meta pausou os envios deste número. Verifique o método de pagamento e a qualidade do número na sua conta Meta.'}
            </p>
          </div>
        </div>
      )}

      {account.status === 'active' && (
        <div className="flex gap-2 items-center rounded-md bg-green-50 border border-green-200 p-3">
          <CheckCircle2 className="w-5 h-5 text-green-600 shrink-0" />
          <p className="text-sm text-green-900 font-medium">
            WhatsApp conectado e enviando pelo número da sua loja.
          </p>
        </div>
      )}

      <div className="rounded-lg border border-gray-200 bg-white p-6">
        <h3 className="font-semibold text-gray-900 mb-2">Conta conectada</h3>
        <Linha rotulo="Número">{account.phoneNumber || '—'}</Linha>
        <Linha rotulo="Nome de exibição">
          {account.displayName || '—'}
          {account.displayNameStatus === 'PENDING_REVIEW' && (
            <span className="ml-2 rounded-full bg-amber-100 px-2 py-0.5 text-xs text-amber-800">
              em revisão
            </span>
          )}
        </Linha>
        <Linha rotulo="Qualidade do número">
          <Qualidade rating={account.qualityRating} />
        </Linha>
        <Linha rotulo="Limite de envios por 24h">
          {account.messagingLimit ? Number(account.messagingLimit).toLocaleString('pt-BR') : '—'}
        </Linha>
        <Linha rotulo="Método de pagamento na Meta">
          {account.hasPaymentMethod ? (
            <span className="text-green-700">cadastrado</span>
          ) : (
            <span className="text-red-700">pendente</span>
          )}
        </Linha>
      </div>

      {!account.hasPaymentMethod && (
        <div className="flex gap-3 items-start rounded-md bg-amber-50 border border-amber-200 p-4">
          <AlertTriangle className="w-5 h-5 mt-0.5 text-amber-600 shrink-0" />
          <p className="text-sm text-amber-900">
            Cadastre um cartão na sua conta Meta para que os envios funcionem. Sem
            método de pagamento, a Meta bloqueia as mensagens.
          </p>
        </div>
      )}

      <p className="text-xs text-gray-500">
        Para desconectar, abra o WhatsApp Business no celular em{' '}
        <strong>Configurações → Conta → Plataforma Business</strong>.
      </p>
    </div>
  )
}
